export default [
	{
		path: "/pros/calendar",
		exact: true,
		policy: "providerAuth",
		component: "Calendar",
		mui: true,
	},
];
